export const TrNoItems = ({ title }: { title: string }) => (
  <tr data-testid="tr_noItems">
    <td colSpan={100} className="pb-4 pt-12 text-center text-400">
      {title}
    </td>
  </tr>
);
